const api = '/api/v1/code.php';
import axios from 'axios';
export const codeRepository =  {
    methods: {
        async GetCode(){
            return  axios.get(api)
        }
    }
};

